import React from "react";
import { Box, Typography } from "@mui/material";
import { wbsLabel, docNumberLabel } from "../../../../../../components/Drawers/TreeViewDrawer/useEmsProjectsTreeData";
import SharePointFolderBrowser from "./SharePointFolderBrowser";

/**
 * Right-pane view shown by EmsExplorer when a Documents tree node is
 * clicked. Documents carry no SharePoint reference of their own (see
 * DOCUMENT_REGISTER_GUIDE.md) - the real, documented SharePoint folder
 * tree only goes down to plant/project (see sharepoint.md), so this opens
 * the document's own project's folder rather than a folder scoped to just
 * that one document.
 */
export default function DocumentFilesPanel({ plant, wbs, doc, onOpenFile }) {
  if (!doc) return null;

  const docNo = docNumberLabel(doc);

  return (
    <Box sx={{ p: 3, height: "100%", overflowY: "auto" }}>
      <Typography variant="overline" color="text.secondary">
        {plant?.name} / {wbsLabel(wbs)}
      </Typography>
      <Typography variant="h6" sx={{ mb: 0.5 }}>
        {docNo}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {doc?.description || doc?.title || "—"}
        {doc?.revision ? ` · Rev ${doc.revision}` : ""}
        {doc?.type ? ` · ${doc.type}` : ""}
      </Typography>

      <SharePointFolderBrowser
        plantName={plant?.name}
        projectName={wbsLabel(wbs)}
        onOpenFile={onOpenFile}
      />
    </Box>
  );
}
